import type { DeepRequired } from '../fixtures.types'

const note: DeepRequired<Note> = {
  __typename: 'Note',
  note_id: 'TEST_ID',
  created_at: null,
  modified_at: null,
  title: null,
  priority: null,
  status: null,
  body: null,
  primary_type: null,
  communication_type: null,
  deadline: null,
  assignee_id: null,
  assignee_type: null,
  case_id: null,
  case: null,
  client_id: null,
  client: null,
  property_id: null,
  mortgage_id: null,
  verification_id: null,
  organisation_ids: [],
  created_by: null,
  template_id: null,
  template: null,
  event_note: null,
  ui_reference: null,
  created_by_user: null,
  creator: null,
}

export default note
